import styled from '@emotion/styled';
import { ContentWrap, Css, ITheme, Responsive } from '../../../../ui';
import { Shadow } from '../../../../styles/Shadow';
import { getGradientBackground } from '../../../../styles/gradients';
import { Z_INDEX_NAV_WRAPPER } from '../../../../styles/zIndex';
import { Color } from '../../../../styles/Color';

export const StickyWrapper = styled(ContentWrap)<
	{ isSticky: boolean; stickyTop: number },
	ITheme
>`
	width: calc(100% - 32px);
	position: ${({ isSticky }) => (isSticky ? 'fixed' : 'unset')};
	margin: 0 auto;
	top: ${({ stickyTop }) => Css.pxToRem(stickyTop)};
	left: 0;
	right: 0;
	z-index: ${Z_INDEX_NAV_WRAPPER};

	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		width: 100%;
		margin: 0;
	}
`;

export const Container = styled.div<{ isSticky: boolean }>`
	min-height: ${Css.pxToRem(144)};
	position: relative;
	display: flex;
	flex-direction: column;
	align-items: center;
	${StickyWrapper} {
		margin: 0 auto;
	}
	${({ isSticky }) =>
		!isSticky &&
		`
		${StickyWrapper} {
			margin: 0;
		}
	`}

	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		min-height: ${Css.pxToRem(72)};
	}
`;

export const NavigationContainer = styled.div<
	{ isSticky: boolean; isHomePage: boolean; isSearchOpen: boolean },
	ITheme
>`
	margin-top: ${Css.pxToRem(16)};
	${({ isSearchOpen }) => !isSearchOpen && getGradientBackground('blue-blue')};
	border-radius: ${Css.pxToRem(8)};
	box-shadow: ${({ isSticky }) => (isSticky ? Shadow.ExtraSmall : 'none')};
	margin: ${({ isSticky }) => isSticky && `${Css.pxToRem(16)}`};

	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		margin: 0;
	}

	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		padding: ${Css.pxToRem(8)} ${Css.pxToRem(24)};
		border-radius: 0;
		${({ isHomePage, isSticky, isSearchOpen }) =>
			getStickyHeaderBg({ isHomePage, isSticky, isSearchOpen })}
	}
`;

const getStickyHeaderBg = ({
	isHomePage,
	isSticky,
	isSearchOpen,
}: {
	isHomePage: boolean;
	isSticky: boolean;
	isSearchOpen: boolean;
}) => {
	if (isSearchOpen) {
		return 'background: transparent;';
	}
	if (isHomePage) {
		return isSticky
			? `background: ${Color.BlueGradient};`
			: 'background: transparent;';
	}
	return `${getGradientBackground('blue-blue-mobile')};`;
};
